import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { EventPresetType } from 'src/app/shared';
import { EventPresetItem, ISelectEventPresetPopupComponentResult } from './declarations';
import { DomSanitizer } from '@angular/platform-browser';

export const EVENT_PRESETS_ITEMS = [
    {
        type: EventPresetType.registrationBasic,
        label: 'BASIC_REGISTRATION',
        imageSrc: 'assets/img/event-preset/public.png',
        zipFileUrl: 'https://staging.azavista.com/asset/67c8bdde2a1478269f86610f/Basic%20Registration.zip',
        globalEntity: {
            email: true,
            website: true,
        },
    },
    {
        type: EventPresetType.registrationApproval,
        label: 'REGISTRATION_APPROVAL',
        imageSrc: 'assets/img/event-preset/manual-approval.png',
        zipFileUrl: 'https://staging.azavista.com/asset/67c8be342a1478269f86612b/Registration%3AApproval.zip',
        globalEntity: {
            email: true,
            website: true,
        },
    },
    {
        type: EventPresetType.registrationWaitingList,
        label: 'REGISTRATION_WAITING_LIST',
        imageSrc: 'assets/img/event-preset/waiting-list.png',
        zipFileUrl: 'https://staging.azavista.com/asset/67c8befd2a1478269f866147/Registration%3AWaiting-list.zip',
        globalEntity: {
            email: true,
            website: true,
        },
    },
    {
        type: EventPresetType.registrationPaid,
        label: 'REGISTRATION_PAID_EVENT',
        imageSrc: 'assets/img/event-preset/paid-entrance.png',
        zipFileUrl: 'https://staging.azavista.com/asset/67c8bff12a1478269f866176/Registration%3APaid%20event.zip',
        globalEntity: {
            email: true,
            website: true,
            payment: true,
        },
    },
    {
        type: EventPresetType.registrationPaidWaitingList,
        label: 'REGISTRATION_PAID_EVENT_WAITING_LIST',
        imageSrc: 'assets/img/event-preset/waiting-list.png',
        zipFileUrl: 'https://staging.azavista.com/asset/67c8c04e2a1478269f866192/Registration%3APaid%20events%20and%20Waiting-list.zip',
        globalEntity: {
            email: true,
            website: true,
            payment: true,
        },
    },
    {
        type: EventPresetType.invitation,
        label: 'INVITE_ONLY',
        imageSrc: 'assets/img/event-preset/invite-only.png',
        zipFileUrl: 'https://staging.azavista.com/asset/6786eddf0eb0e5f268d01067/Event%20accessible%20only%20on%20invitation.zip',
        globalEntity: {
            email: true,
            website: true,
        },
    },
    {
        type: EventPresetType.public,
        label: 'PUBLIC_REGISTRATION',
        imageSrc: 'assets/img/event-preset/public.png',
        zipFileUrl: 'https://staging.azavista.com/asset/6786ede40eb0e5f268d01069/Event%20publicly%20accessible.zip',
        globalEntity: {
            email: true,
            website: true,
        },
    },
    {
        type: EventPresetType.onsiteConference,
        label: 'ONSITE_CONFERENCE',
        imageSrc: 'assets/img/event-preset/public.png',
        zipFileUrl: 'https://staging.azavista.com/asset/67c8bce92a1478269f86610d/Onsite%20conference.zip',
        globalEntity: {
            email: true,
        },
    },
    {
        type: EventPresetType.designTemplate,
        label: 'DESIGN_TEMPLATE',
        svgContent: '<path d="M160-120v-170l527-526q12-12 27-18t30-6q16 0 30.5 6t25.5 18l56 56q12 11 18 25.5t6 30.5q0 15-6 30t-18 27L330-120H160Zm80-80h56l393-392-28-29-29-28-392 393v56Zm560-503-57-57 57 57Zm-139 82-29-28 57 57-28-29ZM560-120q74 0 137-37t63-103q0-36-19-62t-51-45l-59 59q23 10 36 22t13 26q0 23-36.5 41.5T560-200q-17 0-28.5 11.5T520-160q0 17 11.5 28.5T560-120ZM183-426l60-60q-20-8-31.5-16.5T200-520q0-12 18-24t76-37q88-38 117-69t29-70q0-55-44-87.5T280-840q-45 0-80.5 16T145-785q-11 13-9 29t15 26q13 11 29 9t27-13q14-14 31-20t42-6q41 0 60.5 12t19.5 28q0 14-17.5 25.5T262-654q-80 35-111 63.5T120-520q0 32 17 54.5t46 39.5Z"/>',
        globalEntity: {
            email: true,
            website: true,
        },
    },
    {
        type: EventPresetType.hubEventCalendar,
        label: 'HUB_EVENT_WITH_CALENDAR',
        imageSrc: 'assets/img/event-preset/event-with-activities.png',
        zipFileUrl: 'https://staging.azavista.com/asset/67c8c0d42a1478269f8661ae/Hub%20with%20Event%20Calendar.zip',
        globalEntity: {
            email: true,
            website: true,
        },
    },
] satisfies EventPresetItem[];

@Component({
    templateUrl: 'select-event-preset-popup.component.html',
    styleUrls: ['select-event-preset-popup.component.css'],
})
export class SelectEventPresetPopupComponent {

    allEventPresets = EVENT_PRESETS_ITEMS;

    searchText?: string;

    listMode: 'grid' | 'list' = 'grid';

    constructor(
        private readonly dialogRef: MatDialogRef<SelectEventPresetPopupComponent, ISelectEventPresetPopupComponentResult>,
        private sanitizer: DomSanitizer,
    ) {}

    // onInviteOnlyClick(): void {
    //     this.close(EventPresetType.invitation);
    // }

    // onPublicClick(): void {
    //     this.close(EventPresetType.public);
    // }

    // onPaidEntranceClick(): void {
    //     this.close(EventPresetType.paidEntrance);
    // }

    // onManualApprovalClick(): void {
    //     this.close(EventPresetType.manualApproval);
    // }

    // onWaitingListClick(): void {
    //     this.close(EventPresetType.waitingList);
    // }

    // onEventWithActivitiesClick(): void {
    //     this.close(EventPresetType.eventWithActivities);
    // }

    // onOnsiteConferenceClick(): void {
    //     this.close(EventPresetType.onsiteConference);
    // }

    // onDesignTemplateClick(): void {
    //     this.close(EventPresetType.designTemplate);
    // }

    close(presetItem: EventPresetItem): void {
        this.dialogRef.close({ presetItem });
    }

    bypassSecurityTrustHtml = (htmlString: string) => {
        return this.sanitizer.bypassSecurityTrustHtml(htmlString);
    };

    onSearchTextChanges(text: string) {
        this.searchText = text;
    }

    isContainSearchText = (searchText: string | undefined, stringToTest: string) => {
        return !searchText || stringToTest.toLowerCase().includes(searchText.toLowerCase());
    };
}
